// Msg 895 — standard material declaration options (kept in sync with backend).
export const STD_MATERIALS = [
  "Acrylic", "Sunboard / Foam Board", "MDF", "ACP / Aluminium Composite Panel",
  "Aluminium", "Vinyl", "Frosted Vinyl", "Clear Acrylic", "PVC Board",
  "Flex / Banner", "LED Modules", "Neon Flex", "Stainless Steel", "MS Frame",
  "Glass Film", "Laminate", "Paint Finish",
];

export const STD_THICKNESS = ["1mm", "2mm", "3mm", "4mm", "5mm", "6mm", "8mm", "10mm", "12mm", "18mm", "Custom"];

export const STD_COLOURS = [
  "White", "Black", "Red", "Blue", "Green", "Yellow", "Grey", "Silver", "Gold",
  "Transparent", "Frosted", "Matte", "Glossy", "Metallic", "Wood Finish", "Custom",
];

export const MATERIAL_STATUS_META = {
  pending: { label: "Pending Material Details", cls: "bg-amber-100 text-amber-800 border-amber-300" },
  submitted: { label: "Submitted to Procurement", cls: "bg-blue-100 text-blue-700 border-blue-300" },
  in_progress: { label: "Procurement In Progress", cls: "bg-violet-100 text-violet-700 border-violet-300" },
  procured: { label: "Procured", cls: "bg-emerald-100 text-emerald-700 border-emerald-300" },
};
